import * as React from "react";
import { AllIconNames, Hint } from "react-ui";
import * as Icons from "@skbkontur/icons";
import { IconWeight } from "@skbkontur/icons/internal/Icon";

import { AbsoluteModelPath } from "../../../../Common/ModelPath/ModelPath";
import { FocusManagementObserver } from "../Services/FocusManagement/FocusManagementObserver";
import { emptyRef } from "../TypingUtils";
import { tryScrollIntoViewWithFallback } from "../../Helpers/BrowserHelpers";
import { getCandyHub } from "../../Forms/Sentry/InitializeSentry";

export interface IconProps {
    bindingPath?: AbsoluteModelPath;
    name: AllIconNames;
    weight?: IconWeight;
    color?: string;
    size?: 16 | 20 | 24 | 32 | 64 | number;
    align?: "center" | "baseline" | "none";
    className?: string;
    hint?: React.ReactNode;
}

export function Icon(props: IconProps): JSX.Element {
    const rootRef = React.useRef<HTMLSpanElement>(emptyRef);

    const handleFocusRequest = (): void => {
        if (rootRef.current != undefined) {
            tryScrollIntoViewWithFallback(rootRef.current, { block: "center", inline: "center" });
        }
    };

    return (
        <FocusManagementObserver onRequestFocus={handleFocusRequest}>
            <Hint text={props.hint}>
                <span ref={rootRef}>
                    <InternalIcon {...props} />
                </span>
            </Hint>
        </FocusManagementObserver>
    );
}

interface IconConverterProps {
    icon: AllIconNames | React.ReactElement;
}
export function IconConverter(props: IconConverterProps): JSX.Element {
    if (typeof props.icon === "string") {
        return <Icon name={props.icon} />;
    } else {
        return props.icon;
    }
}

// Экспорт internalIcon нужен, чтобы пробрасывать в компоненты, в которых иконка является вспомогательным элементом
// и не требует навигации, например fxInput
export function InternalIcon({ name, color, size, className, weight }: IconProps): JSX.Element {
    // @ts-ignore
    const IconComponent = Icons[name];
    if (IconComponent) {
        return <IconComponent size={size ?? 14} className={className} color={color} weight={weight} />;
    }
    getCandyHub().captureException(new Error(`Cannot find icon with name: ${name}`));
    return <></>;
}
